/* global Cookies, attachEvent,slideUp, slideDown */

const cookieElement = document.querySelectorAll('.cookie-banner-wrapper');

if (cookieElement.length > 0) {
  if (!Cookies.get('cookie-banner-seen')) {
    cookieElement[0].classList.add('cookie-not-set');
  }

  // eslint-disable-next-line no-unused-vars
  attachEvent('.btn--cookie', 'click', (ev) => {
    ev.preventDefault();
    let cookieValue = 'cookie-not-set';
    if (document.getElementById('detail_option1').checked) {
      cookieValue = 'cookie-set';
    }
    Cookies.set('cookie-banner-seen', cookieValue, { expires: 7 });
    cookieElement[0].classList.remove('cookie-not-set');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  });
}

// **************************************************
// 1.0 - Cookie banner details toggle
// **************************************************

attachEvent('.cookie-banner__detail-btn', 'click', (ev) => {
  const detailsBtn = ev.target.closest('.cookie-banner');
  const detailsDropdown = detailsBtn.querySelectorAll('.cookie-banner__details')[0];

  if (detailsBtn.classList.contains('is-open-details')) {
    slideUp(detailsDropdown, 400);
    detailsBtn.classList.remove('is-open-details');
  } else {
    detailsBtn.classList.add('is-open-details');
    slideDown(detailsDropdown, 400);
  }
});

// *******************************************************************************
// 1.2 - Open modal
// *******************************************************************************

attachEvent('.cookie-modal-toggle-btn', 'click', (ev) => {
  ev.preventDefault();
  const parentModalElem = ev.target.closest('.cookie-banner-wrapper');
  parentModalElem.querySelector('.cookie-modal').classList.add('is-open-modal');
});

attachEvent('.cookie-modal__close-btn', 'click', (ev) => {
  ev.preventDefault();
  let cookieValue = 'cookie-not-set';
  if (document.getElementById('cc-preference-selector-analytics').value === 'yes') {
    cookieValue = 'cookie-set';
  }
  Cookies.set('cookie-banner-seen', cookieValue, { expires: 7 });
  ev.target.closest('.cookie-modal').classList.remove('is-open-modal');
});
